import {Link, useLocation} from "react-router-dom";
import "./navbar.css"
import {CgProfile} from "react-icons/cg";
import {connect} from "react-redux";
import {login, logout} from '../../action/auth'
import "../../style.css"

//state
const Navbar = ({isOperator, isAuthenticated, login, logout, user, accessToken, refreshToken}) => {
    const callLogin = () => {
        if (isAuthenticated) {
            logout(true);
        } else {
            login();
        }
    }

    let userName = "";
    if (user) {
        userName = user.preferred_username
    } else {
        userName = null
    }
    const location = useLocation();

    return (
        <div id="header">
            <div id="navbar">
                <nav className="nav-link" id="nav-left">
                    <Link to="/"><img alt="Mapitaly" className='logoImage'
                                      src={"static/images/logo/asi-white-small.png"}/></Link>
                </nav>
                <nav className="nav-link" id="nav-right">
                    {isAuthenticated ? <>
                        {userName ? <span className={'welcome_text'}>Welcome, <strong>{userName}</strong> <CgProfile color="white"/></span> : null}

                        {!isOperator ? <Link className={location.pathname === "/" ? "current" : null} to="/">Search</Link> : <></>}

                        {isOperator ? <Link className={location.pathname === "/" ? "invalidate" : null} to="invalidate">Invalidation</Link> : <></>}
                        {isOperator ? <Link className={location.pathname === "/" ? "reprocess" : null} to="reprocess">Massive Reprocessing</Link> : <></>}

                        <Link className={location.pathname.startsWith("/profile") ? "current" : null} to="profile">My Account</Link>

                        <Link onClick={() => logout()}>LOGOUT</Link>
                    </> : <>
                        <Link onClick={() => callLogin()}>LOGIN</Link>
                    </>}
                </nav>
            </div>
        </div>
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    isOperator: state.auth.isOperator,
    user: state.auth.user,
    accessToken: state.auth.access,
    refreshToken: state.auth.refresh,
});
export default connect(mapStateToProps, {login, logout})(Navbar);
